import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "src/pages/Dashboard/Pages/AuthLayout.vue";

// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";

// Page Headers
const DashboardHeader = () => import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/DashboardHeader.vue");
import DefaultHeader from "src/pages/Dashboard/DefaultHeader";

// My account page
import UserProfile from "@/pages/Dashboard/Examples/UserProfile.vue";

// User Management
import UserList from "../pages/Settings/User/UserList";
import UserForm from "../pages/Settings/User/UserForm";

import CommandList from "../pages/Dashboard/Command/CommandList";
import CommandForm from "../pages/Dashboard/Command/CommandForm";
import DeviceForm from "../pages/Dashboard/Command/DeviceForm";

import ArticleList from "../pages/Settings/Article/ArticleList";
import ArticleForm from "../pages/Settings/Article/ArticleForm";

import CustomerList from "../pages/Settings/Customer/CustomerList";
import CustomerForm from "../pages/Settings/Customer/CustomerForm";

import MetadataList from "../pages/Settings/Metadata/MetatdataList";
import MetadataForm from "../pages/Settings/Metadata/MetadataForm";

import SubscriptionList from "../pages/Dashboard/Subscriptions/SubscriptionList";

import MigrationForm from "../pages/Settings/Migration/MigrationForm";

import FncList from "../pages/Dashboard/Fnc/FncList";
import FncForm from "../pages/Dashboard/Fnc/FncForm";
import FncAdmin from "../pages/Settings/Fnc/FncAdmin";
import Fnc from "../pages/Dashboard/Fnc/Fnc";

import AnomaliesList from "../pages/Dashboard/Anomalies/AnomaliesList.vue";
import AnomaliesForm from "../pages/Dashboard/Anomalies/Form.vue";
import ProductDocumentationList from "../pages/Dashboard/ProductDocumentation/ProductDocumentationList.vue";

import ProductForm from "../pages/Dashboard/Pages/FncAdmin/ProductForm";
import SupplierForm from "../pages/Dashboard/Pages/FncAdmin/SupplierForm";
import ContactForm from "../pages/Dashboard/Pages/FncAdmin/ContactForm";

import FncReporting from "../pages/Dashboard/Dashboard/Reporting/FNC.vue";
import AnomlyReporting from "../pages/Dashboard/Dashboard/Reporting/Anomalies.vue";
// Components pages
const Notifications = () => import(/* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Notifications.vue");
const Icons = () => import(/* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Icons.vue");
const Typography = () => import(/* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Typography.vue");

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/Dashboard.vue");

const Login = () => import(/* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Login.vue");
const PasswordReset = () => import(/* webpackChunkName: "password" */ "src/pages/Dashboard/Password/Reset.vue");
const PasswordEmail = () => import(/* webpackChunkName: "password" */ "src/pages/Dashboard/Password/Email.vue");

const ExternFncForm = () => import(/* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Layout.vue");

// Import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
import admin from "@/middleware/admin";

// Should be removed when useless
let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications, header: DefaultHeader },
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons, header: DefaultHeader },
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography, header: DefaultHeader },
    },
  ],
};

let ReportingMenu = {
  path: "/reporting",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Reportings",
  children: [
    {
      path: "Fnc",
      name: "Fnc Reporting",
      components: { default: FncReporting, header: DefaultHeader },
      meta: { middleware: auth },
    },
    {
      path: "Anomalies",
      name: "Anomalies Reporting",
      components: { default: AnomlyReporting, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let userMenu = {
  path: "/users",
  component: DashboardLayout,
  name: "Users",
  children: [
    {
      path: "user-profile",
      name: "User Profile",
      components: { default: UserProfile, header: DefaultHeader },
      meta: { middleware: auth },
    },

    {
      path: "list",
      name: "User List",
      components: { default: UserList, header: DefaultHeader },
      meta: { middleware: admin },
    },

    {
      path: "create",
      name: "User Create",
      components: { default: UserForm, header: DefaultHeader },
      meta: { middleware: admin },
    },

    {
      path: ":id/edit",
      name: "User Edit",
      components: { default: UserForm, header: DefaultHeader },
      meta: { middleware: admin },
    },

    {
      path: "form",
      redirect: { name: "User Create" },
    }
  ],
};

let commandMenu = {
  path: "/commands",
  component: DashboardLayout,
  name: "Commands",
  children: [
    {
      path: "M4",
      name: "M4",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [1] },
      meta: { middleware: auth },
    },
    {
      path: "WILINE",
      name: "Wi-line",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [2] },
      meta: { middleware: auth },
    },
    {
      path: "Horaflex",
      name: "Horaflex",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [3] },
      meta: { middleware: auth },
    },
    {
      path: "SpeedControl",
      name: "Speed C.",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [4] },
      meta: { middleware: auth },
    },
    {
      path: "checkbox",
      name: "Checkbox",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [5] },
      meta: { middleware: auth },
    },
    {
      path: "Proxy",
      name: "Proxy",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [6] },
      meta: { middleware: auth },
    },
    {
      path: "Software",
      name: "Logiciel",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [7] },
      meta: { middleware: auth },
    },
    {
      path: "WIFI",
      name: "WIFI",
      components: { default: CommandList, header: DefaultHeader },
      props: { type_id: [8] },
      meta: { middleware: auth },
    },


    {
      path: "form",
      name: "Command Form",
      components: { default: CommandForm, header: DefaultHeader },
      meta: { middleware: auth },
      beforeRouteUpdate: (to, from, next) => {
        // if (window.App.username != null) {
        //   return (window.location.href = '/dashboard')
        // }
        // console.log('to :', to)

        // next({
        //   ...to,
        //   query: {
        //     // This line is used to retain other query if there is any
        //     ...to.query,
        //     page: 1,
        //   },
        // });
        // next()
      }
    },
    {
      path: "device/form",
      name: "Command Device Form",
      components: { default: DeviceForm, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let subscriptionMenu = {
  path: "/subscriptions",
  component: DashboardLayout,
  name: "Subscriptions",
  children: [
    {
      path: "list",
      name: "Subscription List",
      components: { default: SubscriptionList, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let fncMenu = {
  path: "/fnc",
  component: DashboardLayout,
  name:"fnc",
  children: [
    {
      path: "list",
      name: "fnc list",
      components: { default: FncList, header: DefaultHeader},
      meta: { middleware: auth },
    },
    {
      path: "show/:id",
      name: "fnc",
      components: { default: Fnc },
      meta: { middleware: auth, compactHeader: true },
    },
    {
      path: "form",
      name: "fnc form",
      components: { default: FncForm, header: DefaultHeader},
      meta: { middleware: auth },
    },
    {
      path: "admin",
      name: "fnc admin",
      components: { default: FncAdmin, header: DefaultHeader},
      meta: { middleware: auth },
    },
    {
      path: "product-form",
      name: "product form",
      components: { default: ProductForm, header: DefaultHeader},
      meta: { middleware: auth },
    },
    {
      path: "supplier-form",
      name: "supplier form",
      components: { default: SupplierForm, header: DefaultHeader},
      meta: { middleware: auth },
    },
    {
      path: "contact-form",
      name: "contact form",
      components: { default: ContactForm, header: DefaultHeader},
      meta: { middleware: auth },
    },
  ],

};

let articleMenu = {
  path: "/articles",
  component: DashboardLayout,
  name: "Articles",
  children: [
    {
      path: "list",
      name: "Article List",
      components: { default: ArticleList, header: DefaultHeader },
      meta: { middleware: auth },
    },
    {
      path: "form",
      name: "Article Form",
      components: { default: ArticleForm, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let AnomaliesMenu = {
  path: "/anomalies",
  component: DashboardLayout,
  name: "Anomalies",
  children: [
    {
      path: "list/:id?",
      name: "Anomalies List",
      components: { default: AnomaliesList, header: DefaultHeader },
      meta: { middleware: auth },
    },
    {
      path: "form",
      name: "Anomalies Form",
      components: { default: AnomaliesForm, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let productDocumentationMenu = {
  path: "/product-documentations",
  component: DashboardLayout,
  name: "Product Documentations",
  children: [
    {
      path: "list",
      name: "Product Documentation List",
      components: { default: ProductDocumentationList, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let customerMenu = {
  path: "/customers",
  component: DashboardLayout,
  name: "Customers",
  children: [
    {
      path: "list",
      name: "Customer List",
      components: { default: CustomerList, header: DefaultHeader },
      meta: { middleware: auth },
    },
    {
      path: "form",
      name: "Customer Form",
      components: { default: CustomerForm, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let migrationForm = {
  path: "/migration",
  component: DashboardLayout,
  name: "Migration",
  children: [
    {
      path: "form",
      name: "Migration Form",
      components: { default: MigrationForm, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let metadataMenu = {
  path: "/metadatas",
  component: DashboardLayout,
  name: "Metadatas",
  children: [
    {
      path: "list",
      name: "Metadata List",
      components: { default: MetadataList, header: DefaultHeader },
      meta: { middleware: auth },
    },
    {
      path: "form",
      name: "Metadata Form",
      components: { default: MetadataForm, header: DefaultHeader },
      meta: { middleware: auth },
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest },
    },
    {
      path: "/register",
      name: "Register",
      redirect: { name: "Login" },
    },
    {
      path: "/password/reset",
      name: "PasswordReset",
      component: PasswordReset,
      meta: { middleware: guest }
    },
    {
      path: "/password/email",
      name: "PasswordEmail",
      component: PasswordEmail,
      meta: { middleware: guest }
    },
  ],
};

let ExternForm = {
  path: "/extern/fnc/:uuid",
  component: ExternFncForm,
  name: "Extern FNC",
  meta: { middleware: guest },
  props: true
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
  },
  componentsMenu,
  ReportingMenu,
  userMenu,
  commandMenu,
  subscriptionMenu,
  fncMenu,
  AnomaliesMenu,
  productDocumentationMenu,
  articleMenu,
  customerMenu,
  metadataMenu,
  migrationForm,
  authPages,
  ExternForm,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard, header: DashboardHeader },
        meta: { middleware: auth },
      },

    ],
  },
  { path: "*", component: NotFound },
];

export default routes;
